import { render } from "./NotFoundCompany.vue?vue&type=template&id=0bccb84b"
import script from "./NotFoundCompany.vue?vue&type=script&lang=js"
export * from "./NotFoundCompany.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__